import React from 'react';
import Header from '../../components/Home/Header';
import Hero from '../../components/Home/Hero';
import Features from '../../components/Home/Features';
import CTA from '../../components/Home/CTA';
import Footer from '../../components/Home/Footer';
import '../../pages/Home/Home.css';

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Features />
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;